var map = {
	"./countries.en.json": [
		6688,
		"global-i18n_countries_en_json"
	],
	"./countries.sv.json": [
		9775,
		"global-i18n_countries_sv_json"
	],
	"./global.en.json": [
		9413,
		"global-i18n_global_en_json"
	],
	"./global.sv.json": [
		8409,
		"global-i18n_global_sv_json"
	],
	"./languages.en.json": [
		6391,
		"global-i18n_languages_en_json"
	],
	"./languages.sv.json": [
		562,
		"global-i18n_languages_sv_json"
	],
	"./libs.en.json": [
		3516,
		"global-i18n_libs_en_json"
	],
	"./libs.sv.json": [
		623,
		"global-i18n_libs_sv_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2199;
module.exports = webpackAsyncContext;